import Addicon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { Button } from "$components";

type Props = {
  to?: string;
  children?: string;
  style?: Record<string, string | number>;
  disabled?: boolean;
};

export const ButtonLink = ({ to, children, style, disabled }: Props) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="outlined"
      onClick={() => navigate(to)}
      style={{ marginRight: 8, ...style }}
      startIcon={<Addicon />}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
